global.BankIdForm = (function ($) {

	const COMPLETE_STATUS = 0;
	const POLL_TIMEOUT = 2000;
	const QR_TIMEOUT = 1000;

	let deviceKind;
	let qrRefreshTimeout;
	let loginStatusTimeout;

	const statusMessage = document.getElementById('bankid-message');
	const bankIdCheckStatusElement = document.getElementById('bankid-check-status');
	const qrCode = document.getElementById('qrCode');
	const forceStartBtn = document.getElementById('bankid-force-start-btn');
	if (forceStartBtn) {
		forceStartBtn.addEventListener('click', forceStart);
	}
	const cancellationBtn = document.getElementById('bankid-cancellation-btn');
	if (cancellationBtn) {
		cancellationBtn.addEventListener('click', cancel);
	}
	const form = document.getElementById('bankid-form');
	if (form) {
		deviceKind = form.getAttribute('data-device-kind');
	}

	const spinner = document.getElementsByClassName('bankid-form__spinner');
	const qrCodeWrapper = document.getElementsByClassName('bankid-qr-code-wrapper');
	const bankIdForceStartContainer = document.getElementsByClassName('bankid-force-start-container');
	const loginChoiceBtnsContainer = document.getElementsByClassName('js-login-choice-btns-container');
	const loginChoiceBtns = document.getElementsByClassName('js-login-choice-btn');
	if (loginChoiceBtns && loginChoiceBtns.length) {
		for (var i = 0; i < loginChoiceBtns.length; i++) {
			loginChoiceBtns[i].addEventListener('click', initBankId);
		}
	}

	function initBankId(event) {
		event.preventDefault();

		let authenticateOn;
		if (event.target.id === 'bankid-force-start-btn') {
			authenticateOn = 'ThisDevice';
		} else {
			authenticateOn = event.target.value;
		}

		initAuth(authenticateOn);
	}

	function initAuth(authenticateOn) {
		//Göm loginknapparna.
		showLoginChoiceView(false);

		$.ajax({
			url: `Auth?authenticateOn=${authenticateOn}`,
			type: 'POST'
		}).done(function (data) {
			setCancellationBtnAttr('abort');
			if (authenticateOn !== 'OtherDevice') {
				window.open(data.BankIdAppUrl, deviceKind === 'Android' ? '_blank' : '_self');
				showSameDeviceView(true);
			} else {
				//Visa qrkod
				qrCode.src = data.QrCode;
				showOtherDeviceView(true)
			}
			getLoginStatus(authenticateOn)
		}).fail(function () {
			var genericError = form.getAttribute('generic-error');
			showError(genericError, authenticateOn);
		});
	}

	function showLoginChoiceView(visible) {
		visible ?
			toggleGUIVisibility('show', [loginChoiceBtnsContainer[0]])
			:
			toggleGUIVisibility('hide', [loginChoiceBtnsContainer[0]]);
	}

	function showSameDeviceView(visible) {
		visible ?
			toggleGUIVisibility('show', [
				bankIdCheckStatusElement,
				statusMessage,
				spinner[0],
				bankIdForceStartContainer[0]
			])
			:
			toggleGUIVisibility('hide', [
				bankIdCheckStatusElement,
				statusMessage,
				spinner[0],
				bankIdForceStartContainer[0]
			]);
	}

	function showOtherDeviceView(visible) {
		visible ?
			toggleGUIVisibility('show', [
				bankIdCheckStatusElement,
				qrCodeWrapper[0],
				statusMessage,
				bankIdForceStartContainer[0]
			])
			:
			toggleGUIVisibility('hide', [
				bankIdCheckStatusElement,
				qrCodeWrapper[0],
				statusMessage,
				bankIdForceStartContainer[0]
			])
	}

	function forceStart(event) {
		event.preventDefault();
		cancel(event);
	}

	function initPersonalIdentifierForm(hasErrorFromServer) {
		shouldShowErrors = hasErrorFromServer;
	}

	function getLoginStatus(authenticateOn) {
		$.ajax({
			url: 'Status',
			type: 'POST'
		}).done(function (data) {
			statusMessage.innerHTML = data.Message;

			if (data.Id === COMPLETE_STATUS) {
				handleComplete(data, authenticateOn);
				return;
			}
			if (authenticateOn === 'OtherDevice') {
				refreshQrCode(authenticateOn);
				qrRefreshTimeout = setTimeout(function () {
					refreshQrCode(authenticateOn)
				}, QR_TIMEOUT);
			}

			loginStatusTimeout = setTimeout(function () {
				getLoginStatus(authenticateOn);
			}, POLL_TIMEOUT);

		}).fail(function (authenticateOn) {
			const genericError = form.getAttribute('data-generic-error');
			showError(genericError, authenticateOn);
		});
	}

	function refreshQrCode(authenticateOn) {
		$.ajax({
			url: 'QrCode',
			type: 'POST'
		}).done(function (data) {
			qrCode.src = data.QrCode;
		}).fail(function (authenticateOn) {
			var genericError = form.getAttribute('data-generic-error');
			showError(genericError, authenticateOn);
		});
	}

	function setCancellationBtnAttr(cancellationType) {
		cancellationBtn.removeEventListener('click', cancel);
		if (cancellationType === 'previous') {
			cancellationBtn.setAttribute('aria-label', cancellationBtn.getAttribute('data-previous-translation'));
			cancellationBtn.innerText = cancellationBtn.getAttribute('data-previous-translation');
			cancellationBtn.addEventListener('click', resetFlow);
		} else {
			cancellationBtn.setAttribute('aria-label', cancellationBtn.getAttribute('data-cancel-translation'));
			cancellationBtn.innerText = cancellationBtn.getAttribute('data-cancel-translation');
			cancellationBtn.addEventListener('click', cancel);
		}
	}

	function toggleGUIVisibility(visual, elements) {
		visual === 'show' ? elements.map((element) => element.classList.remove('hidden')) : elements.map((element) => element.classList.add('hidden'));
	};

	function resetFlow(event) {
		event.preventDefault();
		showSameDeviceView(false);
		showOtherDeviceView(false);
		showLoginChoiceView(true);
	}

	function cancel(event) {
		event.preventDefault();

		//Stoppa pollingen.
		if (qrRefreshTimeout) {
			clearTimeout(qrRefreshTimeout);
		}

		if (loginStatusTimeout) {
			clearTimeout(loginStatusTimeout);
		}

		let trigger;
		if (event && event.target.id) {
			trigger = event.target.id;
		}
		$.ajax({
			url: 'Cancel',
			type: 'PUT'
		}).done(function (data) {
			if (trigger === 'bankid-force-start-btn') {
				toggleGUIVisibility('hide', [
					qrCodeWrapper[0]
				]);
				initBankId(event);
			} else {
				//Visa inloggningsknappar.
				showLoginChoiceView(true);
				showOtherDeviceView(false);
			}
		}).fail(function () {
			//Visa status och tillbakaknapp.
			var genericError = form.getAttribute('data-generic-error');
			showError(genericError, authenticateOn);
			window.location.href = "/sv/betalningar--kontanter/sedlar--mynt/sedlar/att-losa-in-ogiltiga-sedlar/";
		});
	}

	function handleComplete(data, authenticateOn) {
		if (data.IsError) {
			showError(data.Message, authenticateOn, data.Id);
		} else {
			window.location.href = data.Url;
		}
	}

	function showError(errorMessage, authenticateOn, status) {
		if (authenticateOn === 'ThisDevice' && status !== 0) {
			setCancellationBtnAttr('abort');
		} else {
			setCancellationBtnAttr('previous');
		}

		toggleGUIVisibility('hide', [
			spinner[0],
			qrCodeWrapper[0],
			bankIdForceStartContainer[0]
		]);

		statusMessage.text = errorMessage;
	}
}(jQuery));
